import React from 'react';
import { useParams } from 'react-router-dom';
import CreateWorkOrder from './CreateWorkOrder';

const ViewWorkOrder = () => {
  const { id } = useParams();

  return <CreateWorkOrder viewMode={true} workOrderId={id} />;
};

export default ViewWorkOrder;

